module.exports = __webpack_public_path__ + "img/thumbnail_NorthIslandBrownKiwi_f_normal.e670771f.png";